import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import Datepicker from "../components/Datepicker";
import ModalLoading from "../components/ModalLoading";
import Table from "../components/Table";
import * as XLSX from "xlsx/xlsx.mjs";
import ModalImage from "../components/ModalImage";
import { HEADER, logger } from "../utils/Utils";
import V2MigrationBanner from "../components/Banner/V2MigrationBanner";

export default function TransactionFragment() {
  const user = JSON.parse(localStorage.getItem("dompet_user"));
  const [dataVoucher, setDataVoucher] = useState([]);

  const [dataOutletKartini, setDataOutletKartini] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [dateRange, setDateRange] = useState({
    start_at: new Date().setDate(new Date().getDate() - 6),
    end_at: new Date(),
  });
  const [pageSelected, setPageSelected] = useState(1);
  const [filterData, setFilterData] = useState({
    outlet: [{ label: "All", value: "" }],
  });
  const [filter, setFilter] = useState({
    outlet_kartini_id: null,
  });
  const [isLoadingDownload, setLoadingDownload] = useState(false);

  // * STATE IMAGE MODAL
  const [image, setImage] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    getOutletKartini();
    getDataFilter();
  }, []);

  useEffect(() => {
    setPageSelected(1);
    getVoucher(true);
  }, [dateRange, filter]);

  useEffect(() => {
    if (pageSelected > 1) {
      getVoucher();
    }
  }, [pageSelected]);

  function getOutletKartini() {
    fetch(
      `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini/${user.outlet_kartini_id}`,
      {
        method: "GET", // or 'PUT'
        headers: HEADER,
      },
    )
      .then((res) => res.json())
      .then((data) => {
        // logger("=======EMAIL");
        // logger(data.data);
        setDataOutletKartini({
          ...dataOutletKartini,
          ...data.data,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async function getVoucher(isRefresh) {
    setShowModalLoading(true);
    var start = isRefresh
      ? 1
      : pageSelected > 1
        ? (pageSelected - 1) * 10 + 1
        : 1;

    await fetch(
      `${
        process.env.REACT_APP_BASE_URL_API
      }/v2/collection/redeemer/data?outlet_kartini_id=${
        user.user_type !== "member"
          ? filter.outlet_kartini_id ?? ""
          : dataOutletKartini.outlet_kartini_id
      }&voucher_number_status=redeemed&channel_id=${
        dataOutletKartini.channel_id
      }&start=${start}&length=10&start_at=${moment(dateRange.start_at).format(
        "YYYY-MM-DD",
      )}&end_at=${moment(dateRange.end_at).format("YYYY-MM-DD")}`,
      {
        method: "GET", // or 'PUT'
        headers: HEADER,
      },
    )
      .then((res) => res.json())
      .then((data) => {
        var pages = [];
        for (let i = 0; i < Math.ceil(data.length / 10); i++) {
          pages.push(i + 1);
        }
        setDataVoucher({
          data: data.data,
          pages: pages,
          length: data.length,
          pageSelected: 0,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setShowModalLoading(false);
  }

  const columns = {
    transaction: useMemo(
      () => [
        {
          Header: "No",
          accessor: "index",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "Mobile Number",
          accessor: "mobile",
          Cell: ({ value }) => (
            <div className="text-center">
              +{value.substring(0, value.length - 4) + "XXXX"}
            </div>
          ),
        },
        {
          Header: "Nominal",
          accessor: "nominal",
          Cell: ({ row }) => (
            <div className="text-center">
              {parseInt(
                row.original.discount ?? row.original.nominal,
              ).toLocaleString("id-ID", {
                style: "currency",
                currency: "IDR",
              })}
            </div>
          ),
        },
        {
          Header: "Voucher Code",
          accessor: "voucher_number",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "SKU",
          accessor: "sku_name",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "Status",
          accessor: "voucher_number_status",
          Cell: ({ value }) => (
            <div className="m-1.5 text-center">
              {/* Start */}
              <div
                className={`inline-flex text-sm font-medium ${
                  value === "open"
                    ? "bg-gray-700 text-gray-100"
                    : value === "redeemed" || value === "activated"
                      ? "bg-green-100 text-green-600"
                      : "bg-blue-100 text-blue-600"
                } rounded-full px-2.5 py-1 text-center`}
              >
                {value}
              </div>
              {/* End */}
            </div>
          ),
        },
        {
          Header: "Timestamp",
          Cell: ({ row }) => {
            if (row.original.voucher_number_status === "activated") {
              return (
                <div className="text-center">
                  {row.original.activated_status_date !== null
                    ? moment(row.original.activated_status_date).format(
                        "DD-MM-YYYY HH:mm",
                      )
                    : "-"}
                </div>
              );
            } else if (row.original.voucher_number_status === "booked") {
              return (
                <div className="text-center">
                  {row.original.booked_status_date !== null
                    ? moment(row.original.booked_status_date).format(
                        "DD-MM-YYYY HH:mm",
                      )
                    : "-"}
                </div>
              );
            } else if (row.original.voucher_number_status === "redeemed") {
              return (
                <div className="text-center">
                  {row.original.redeemed_status_date !== null
                    ? moment(row.original.redeemed_status_date).format(
                        "DD-MM-YYYY HH:mm",
                      )
                    : "-"}
                </div>
              );
            } else if (row.original.voucher_number_status === "open") {
              return (
                <div className="text-center">
                  {row.original.open_status_date !== null
                    ? moment(row.original.open_status_date).format(
                        "DD-MM-YYYY HH:mm",
                      )
                    : "-"}
                </div>
              );
            } else {
              return <div className="text-center">-</div>;
            }
          },
        },
      ],
      [],
    ),
    tukar_cangkang: useMemo(
      () => [
        {
          Header: "No",
          accessor: "#",
          Cell: ({ row }) => <div className="text-center">{row.index + 1}</div>,
        },
        {
          Header: "Tanggal",
          accessor: "##",
          Cell: ({ row }) => {
            return (
              <div className="text-center">
                {row.original.created_at !== null
                  ? moment(row.original.created_at).format("DD-MM-YYYY")
                  : "-"}
              </div>
            );
          },
        },
        {
          Header: "Nama Outlet",
          accessor: "outlet_kartini_name",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "SKU",
          accessor: "sku",
          Cell: ({ value }) => (
            <div className="text-center">
              {value.length > 0 ? (
                value.map((sku) => <div>{sku.sku_name}</div>)
              ) : (
                <div>-</div>
              )}
            </div>
          ),
        },
        {
          Header: "Jumlah",
          Cell: ({ row }) => (
            <div className="text-center">
              {row.original.sku.length > 0 ? (
                row.original.sku.map((sku) => <div>{sku.quantity}</div>)
              ) : (
                <div>-</div>
              )}
            </div>
          ),
        },
      ],
      [],
    ),
  };

  function getDataFilter() {
    fetch(
      `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini?channel_id=${dataOutletKartini.channel_id}`,
      {
        method: "GET", // or 'PUT'
        headers: HEADER,
      },
    )
      .then((res) => res.json())
      .then((data) => {
        data = data.data.map((value) => ({
          label: value.outlet_kartini_name,
          value: value.outlet_kartini_id,
        }));
        data.unshift({ label: "All", value: "" });
        setFilterData((prevState) => ({
          ...prevState,
          outlet: data,
        }));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const handleChange = (event) => {
    setFilter({
      outlet_kartini_id: event.value,
    });
  };

  const DownloadReport = async (e) => {
    e.stopPropagation();
    setLoadingDownload(true);
    await fetch(
      `${
        process.env.REACT_APP_BASE_URL_API
      }/v2/collection/redeemer/data?outlet_kartini_id=${
        user.user_type !== "member"
          ? filter.outlet_kartini_id ?? ""
          : dataOutletKartini.outlet_kartini_id
      }&voucher_number_status=redeemed&channel_id=${
        dataOutletKartini.channel_id
      }&length=0&start_at=${moment(dateRange.start_at).format(
        "YYYY-MM-DD",
      )}&end_at=${moment(dateRange.end_at).format("YYYY-MM-DD")}`,
      {
        method: "GET", // or 'PUT'
        headers: HEADER,
      },
    )
      .then((res) => res.json())
      .then((data) => {
        logger(data);
        let data_download = data.data.map((voucher) => ({
          Redemption_Date: voucher.created_at ?? "-",
          Account_Name: voucher.channel_sub_sub_category ?? "-",
          Branch_Name: voucher.outlet_kartini_name ?? "-",
          User_Name: voucher.user_name ?? "-",
          User_Email: voucher.email ?? "-",
          Voucher_Code: voucher.voucher_number ?? "-",
          SKU: voucher.sku_name ?? "-",
          Nominal: parseInt(voucher.nominal ?? voucher.discount),
          Voucher_Status: voucher.voucher_number_status ?? "-",
        }));
        let ws = XLSX.utils.json_to_sheet(data_download);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "sheet");
        XLSX.writeFile(
          wb,
          `Report-${moment(new Date()).format("DDMMYYHHmmss")}.xlsx`,
        );
        setLoadingDownload(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const TableScreen = () => {
    return (
      <>
        <Datepicker align="left" setDate={setDateRange} date={dateRange} />

        {/* TRANSACTION */}
        <Table
          data={dataVoucher.data ?? []}
          pages={dataVoucher.pages ?? []}
          setPageSelected={setPageSelected}
          pageSelected={pageSelected ? pageSelected - 1 : 0}
          title="Voucher"
          columns={columns.transaction}
          // enDatepicker={true}
          isLoading={false}
          date={dateRange}
          setDate={setDateRange}
        />
        <div className="flex flex-col space-y-2">
          <button
            className={`btn-lg bg-[#4CA6F8] text-white ${
              isLoadingDownload &&
              "disabled:cursor-not-allowed disabled:bg-[#CCCCCC] disabled:text-[#7D7C7C]"
            }`}
            disabled={isLoadingDownload}
            onClick={DownloadReport}
          >
            {isLoadingDownload ? (
              <>
                <svg
                  className="h-4 w-4 flex-shrink-0 animate-spin fill-current"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                </svg>
                <span className="ml-2">Loading...</span>
              </>
            ) : (
              <>
                <span className="ml-2">DOWNLOAD REPORT</span>
              </>
            )}
          </button>
        </div>
      </>
    );
  };

  return (
    <div className="space-y-3">
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      {/* MODAL IMAGE */}
      <ModalImage
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        image={image}
        setImage={setImage}
      />
      <V2MigrationBanner />
      {user.user_type !== "member" && (
        <Select
          className="col-span-full sm:col-span-2"
          placeholder="Outlet Name"
          options={filterData.outlet}
          onChange={handleChange}
        />
      )}
      <div className="space-y-5">
        <TableScreen />
      </div>
    </div>
  );
}
